import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Slider from 'rc-slider';
import setPrices from '../../redux/actions/price';
import './style.scss';
import { MIN_PRICE, MAX_PRICE } from '../../constants';

const { createSliderWithTooltip } = Slider;
const Range = createSliderWithTooltip(Slider.Range);

export default () => {
  const prices = useSelector((state) => state.price.prices);
  const dispatch = useDispatch();
  return (
    <div className="b-filter-slider ui-filter-slider">
      <div className="b-filter-slider__title">Price</div>
      <div className="b-filter-slider__main">
        <Range
          min={MIN_PRICE}
          max={MAX_PRICE}
          value={prices}
          step={10}
          tipFormatter={(value) => `€ ${value}`}
          onChange={(array) => {
            dispatch(setPrices(array));
          }}
        />
        <div className="b-filter__row row">
          <div className="b-filter__item col-md-6 col-lg-12 col-xl-6">
            <input
              className="ui-select"
              id="input-with-keypress-0"
              name="MinPrice"
              value={`€ ${prices[0]}`}
              readOnly
            />
          </div>
          <div className="b-filter__item col-md-6 col-lg-12 col-xl-6">
            <input
              className="ui-select"
              id="input-with-keypress-1"
              name="MaxPrice"
              value={`€ ${prices[1]}`}
              readOnly
            />
          </div>
        </div>
      </div>
    </div>
  );
};
